export default "__VITE_ASSET__CRjcrsdo__"